import news from '@/store/modules/news/news'
import editNews from '@/store/modules/news/news-edit'
import createNews from '@/store/modules/news/news-new'
import deleteNews from '@/store/modules/news/news-delete'

export default {
  news,
  editNews,
  createNews,
  deleteNews,
}
